import React from 'react';
import ServiceCard from '../components/ServiceCard';

const About = () => {
  const services = [
    {
      type: 'audio',
      title: 'Audio Monitoring',
      description: 'Comprehensive audio media tracking and analysis',
      url: 'https://www.audio.recordnews.co.za'
    },
    {
      type: 'print',
      title: 'Print Monitoring',
      description: 'Traditional print media coverage and mentions',
      url: 'https://www.print.recordnews.co.za'
    },
    {
      type: 'online',
      title: 'Online Monitoring',
      description: 'Digital news and website coverage tracking',
      url: 'https://www.online.recordnews.co.za'
    },
    {
      type: 'social',
      title: 'Social Media Monitoring',
      description: 'Social platforms conversation tracking',
      url: 'https://www.social.recordnews.co.za'
    },
    {
      type: 'video',
      title: 'Video Monitoring',
      description: 'Video content and broadcast media tracking',
      url: 'https://www.video.recordnews.co.za'
    }
  ];

  return (
    <div className="about-page">
      <div className="container">
        <div className="page-header">
          <h1>About Record News</h1>
          <p className="page-subtitle">Leading media monitoring since 2020</p>
        </div>

        <section className="about-content">
          <div className="about-text">
            <h2>Our Story</h2>
            <p>
              Record News has been at the forefront of media monitoring in South Africa for over a decade. 
              We started with a simple mission: to help businesses understand their media presence across all platforms.
            </p>
            
            <h2>Our Mission</h2>
            <p>
              To provide comprehensive, accurate, and timely media monitoring services that empower businesses 
              to make informed decisions and understand their media landscape.
            </p>

            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Accuracy</h3>
                <p>Precision in every report and analysis we deliver</p>
              </div>
              <div className="value-item">
                <h3>Innovation</h3>
                <p>Constantly evolving our technology and methods</p>
              </div>
              <div className="value-item">
                <h3>Reliability</h3>
                <p>Consistent service you can depend on</p>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section in About Page */}
        <section className="about-services">
          <h2>Our Monitoring Platforms</h2>
          <p>Access our specialized monitoring platforms below:</p>
          <div className="services-grid">
            {services.map((service, index) => (
              <ServiceCard key={index} service={service} />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;